import React, { useCallback } from "react";

import { Field } from "redux-form";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Icon, ReduxControls } from "rhombus-react";
import { SNAPCHAT_COMMON_CONSTRAINTS } from "social/validators/snapchat";
import { nonDynamicFields } from "social/utils";

import "./SnapchatDisclaimer.css";

const DISCLAIMER_NAME_PLACEHOLDER = "Enter a short disclaimer name";
const DISCLAIMER_TEXT_PLACEHOLDER = "This is a disclaimer text entered by the user. Either disclaimer text or disclaimer URL is required";

export default function SnapchatDisclaimer(props){
	const {
		input: { value, onChange } = {},
		disabled = false,
		className = "",
		showPristineErrors,
	} = props;

	const onToggleChange = useCallback((e) => {
		e.stopPropagation();
		if(!disabled){
			onChange(!value);
		}
	}, [disabled, onChange, value]);


	return (
		<div
			className={classNames("snapchat-disclaimer-wrapper", "e-form__control-wrapper", {
				[className]: !!className,
			})}
		>
			<div className="full-width e-form__control-header">
				<div
					className={classNames({
						"snapchat-disclaimer-field": true,
						"is-checked": !!value,
					})}
					onClick={onToggleChange}
					disabled={disabled}
				>
					<div className="snapchat-disclaimer-slider"> </div>
				</div>
				<div className="e-form__control-label">
					Disclaimer&nbsp;
					<Icon name="help-tip fas fa-info-circle" data-tip="Adding disclaimers to your ads could help you avoid legal risks." />
				</div>
			</div>
			{!!value && (
				<div className="full-width">
					<div className="snapchat-disclaimer-body">
						<Field
							name="disclaimerName"
							key="disclaimerName"
							label="Disclaimer Name"
							className="snapchat-disclaimer-textarea"
							component={ReduxControls.Input}
							type="textarea"
							placeholder={DISCLAIMER_NAME_PLACEHOLDER}
							disabled={disabled}
							charMax={SNAPCHAT_COMMON_CONSTRAINTS.MAX_DISCLAIMER_NAME_LENGTH}
							showCharCount
							required
							showPristineErrors={!!showPristineErrors}
							{...nonDynamicFields()}
						/>
						<Field
							name="disclaimerText"
							key="disclaimerText"
							label="Disclaimer Text"
							className="snapchat-disclaimer-textarea"
							component={ReduxControls.Input}
							type="textarea"
							placeholder={DISCLAIMER_TEXT_PLACEHOLDER}
							disabled={disabled}
							charMax={SNAPCHAT_COMMON_CONSTRAINTS.MAX_DISCLAIMER_TEXT_LENGTH}
							showCharCount
							required
							showPristineErrors={!!showPristineErrors}
							{...nonDynamicFields()}
						/>
					</div>
				</div>
			)}
		</div>
	);
}

SnapchatDisclaimer.displayName = "SnapchatDisclaimer";

SnapchatDisclaimer.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.any,
		onChange: PropTypes.func,
	}),
	disabled: PropTypes.bool,
	className: PropTypes.string,
	showPristineErrors: PropTypes.bool,
};
